import * as actions from './actions';
import messages from '../teacher-roll/messages';

const assignEmptyTeacherObject = () => (
    {
        title: '',
        firstName: '',
        lastName: '',
        emailAddress: '',
        userName: '',
        password: '',
        isResetpassword: false,
        adminPassword: '',
        newPassword: '',
        confirmationPassword: ''
    }
);

const initialState = {
    teacherDetail: assignEmptyTeacherObject(),
    updatingTeacher: false,
    isLoadingEditTeacherDetail: false,
    downloadingClassroomIds: new Set(),
    emailStatus: false,
    emailValidationMessage: '',
    showEditTeacherValidationModal: false,
    enableSave: false
};

export default function (state = initialState, action) {
    switch (action.type) {
    case actions.GET_TEACHER_REQUEST: {
        return { ...state, isLoadingEditTeacherDetail: action.isLoadingEditTeacherDetail };
    }

    case actions.GET_TEACHER_SUCCESS: {
        return { ...state, editTeacherDetail: action.data, isLoadingEditTeacherDetail: action.isLoadingEditTeacherDetail, teacherDetail: action.data };
    }
    case actions.EDIT_TEACHER_REQUEST:
    {
        return { ...state, updatingTeacher: true, enableSave: false };
    }
    case actions.EDIT_TEACHER_SUCCESS_REQUEST:
    {
        return { ...state, updatingTeacher: false, teacherDetail: assignEmptyTeacherObject(), enableSave: false };
    }
    case actions.EDIT_TEACHER_FAILURE_REQUEST:
    {
        let errorMessage = '';
        if (action.isServerError) {
            errorMessage = messages.errorMessageHeader;
        } else {
            errorMessage = action.editTeacherValidationMessage;
        }
        return { ...state, updatingTeacher: false, showEditTeacherValidationModal: action.showEditTeacherValidationModal, editTeacherValidationMessage: errorMessage };
    }
    case actions.CLOSE_EDIT_TEACHER_VALIDATION_MODAL:
    {
        return { ...state, showEditTeacherValidationModal: action.showEditTeacherValidationModal };
    }

    case actions.GET_TEACHER_FAILURE: {
        return { ...state, editTeacherDetail: [], isLoadingEditTeacherDetail: action.isLoadingEditTeacherDetail };
    }

    case actions.OPEN_UNASSIGN_TEACHERS_MODAL: {
        return { ...state, isUnassignedModalOpen: action.isUnassignedModalOpen };
    }

    case actions.UNASSIGN_TEACHERS_USING_CLASSID_REQUEST: {
        return { ...state, unassignDisableButton: action.unassignDisableButton, isUnassignedModalOpen: action.isUnassignedModalOpen };
    }

    case actions.UNASSIGN_TEACHERS_USING_CLASSID_SUCCESS: {
        return { ...state, isUnassignedModalOpen: action.isUnassignedModalOpen, unassignDisableButton: action.unassignDisableButton };
    }

    case actions.UNASSIGN_TEACHERS_USING_CLASSID_FAILURE: {
        return { ...state, unassignDisableButton: action.unassignDisableButton };
    }

    case actions.CLOSE_UNASSIGN_TEACHERS_MODAL_CONFIRMATION: {
        return { ...state, refreshTeachersAfterUnAssign: action.refreshTeachersAfterUnAssign };
    }

    case actions.PRINT_CLASSROOM_STUDENTS_SIGN_IN_CARD_REQUEST: {
        return { ...state, downloadingClassroomIds: action.downloadingClassroomIds };
    }

    case actions.PRINT_CLASSROOM_STUDENTS_SIGN_IN_CARD_SUCCESS: {
        return { ...state, downloadingClassroomIds: action.downloadingClassroomIds };
    }

    case actions.PRINT_CLASSROOM_STUDENTS_SIGN_IN_CARD_FAILURE: {
        return { ...state, downloadingClassroomIds: action.downloadingClassroomIds };
    }

    case actions.CLOSE_UNASSIGN_MODAL_REQUEST: {
        return { ...state, isUnassignedModalOpen: false };
    }

    case actions.SEND_PASSWORD_LINK_REQUEST: {
        return { ...state, emailStatus: false, emailValidationMessage: '' };
    }

    case actions.SEND_PASSWORD_LINK_SUCCESS: {
        return { ...state, emailStatus: true, emailValidationMessage: '' };
    }

    case actions.SEND_PASSWORD_LINK_FAILURE: {
        return { ...state, emailStatus: false, emailValidationMessage: action.errorMessage };
    }

    case actions.SEND_VERIFICATION_EMAIL_LINK_REQUEST: {
        return { ...state, emailStatus: false, emailValidationMessage: '' };
    }

    case actions.SEND_VERIFICATION_EMAIL_LINK_SUCCESS: {
        return { ...state, emailStatus: true, emailValidationMessage: '' };
    }

    case actions.SEND_VERIFICATION_EMAIL_LINK_FAILURE: {
        return { ...state, emailStatus: false, emailValidationMessage: action.errorMessage };
    }

    case actions.RESET_PASSWORD_PARAMETERS: {
        return { ...state, emailStatus: false, emailValidationMessage: '' };
    }

    case actions.VALIDATION_ERROR_MODAL_RESET: {
        return { ...state, showEditTeacherValidationModal: false, enableSave: true };
    }

    default:
        return state;
    }
}



// WEBPACK FOOTER //
// ./app/containers/edit-teacher/reducer.js